// Turns Supabase sign-up errors into plain-English messages attached to the
// field they belong to. `reason` is a short code for the sign_up_error GA4 event.
export function describeSignUpError(error) {
  const code = error?.code || ''
  const msg = String(error?.message || '')
  const status = error?.status

  if (code === 'user_already_exists' || code === 'email_exists' || /already (been )?registered|already exists/i.test(msg)) {
    return { field: 'email', reason: 'already_registered', message: 'An account with this email already exists — sign in instead.' }
  }
  if (code === 'email_address_invalid' || code === 'validation_failed' || /invalid.*email|email.*invalid|unable to validate email/i.test(msg)) {
    return { field: 'email', reason: 'invalid_email', message: "That email address doesn't look right — please check it." }
  }
  if (code === 'weak_password' || /password/i.test(msg)) {
    return { field: 'password', reason: 'weak_password', message: 'Please choose a stronger password — at least 6 characters.' }
  }
  if (status === 429 || /rate limit|too many/i.test(msg)) {
    return { field: null, reason: 'rate_limited', message: 'Too many attempts right now — please wait a minute and try again.' }
  }
  if (/failed to fetch|network|load failed/i.test(msg)) {
    return { field: null, reason: 'network', message: "Couldn't connect — check your internet connection and try again." }
  }
  return { field: null, reason: (code || 'unknown').slice(0, 40), message: 'Something went wrong creating your account. Please try again.' }
}

export function describeSignInError(error) {
  const msg = String(error?.message || '')
  if (error?.code === 'invalid_credentials' || /invalid login credentials/i.test(msg)) {
    return 'That email and password don\'t match an account. Check them, or reset your password.'
  }
  if (error?.status === 429 || /rate limit|too many/i.test(msg)) return 'Too many attempts right now — please wait a minute and try again.'
  if (/failed to fetch|network|load failed/i.test(msg)) return "Couldn't connect — check your internet connection and try again."
  return msg || 'Could not sign in. Please try again.'
}

export const looksLikeEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || '').trim())
